<template>
  <div class="container" v-if="alertIsActive">
    <v-icon color="warning" size="30px">
    warning
    </v-icon>
    <p class="alert-text">
      Debe completar este campo {{valorOrEscala()}}
    </p>
  </div>
</template>
<script>

export default {

  props: {
    alertIsActive: Boolean,
    fieldType: Object
  },
  data () {
    return {
    }
  },
  methods: {
    valorOrEscala () {
      let text = ''
      if (this.fieldType.response && this.fieldType.scale) {
        text = ' (Valor y escala)'
        return text
      }
      if (this.fieldType.response === true) {
        text = ' (Valor)'
        return text
      }
      if (this.fieldType.scale === true) {
        text = ' (Escala)'
        return text
      }
    }
  },
  created () {
  }

}
</script>

<style scoped>

.container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: -20px;
}
.alert-text {
  background-color: #FFC107;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 3px;
  padding-bottom: 3px;
  border-radius: 2px;
  font-weight: 600;
}
</style>
